import announcement from '@/assets/announcement.webp'
import hcBoardroom from '@/assets/hc-boardroom.webp'
import hcDesktop from '@/assets/hc-desktop.webp'
import hcLaptop from '@/assets/hc-laptop.webp'
import hcSystem from '@/assets/hc-system.webp'
import hseBoardroom from '@/assets/hse-boardroom.webp'
import hseControlRoom from '@/assets/hse-control-room.webp'
import hseDesk from '@/assets/hse-desk.webp'
import hseDualScreen from '@/assets/hse-dual-screen.webp'
import indConstruction from '@/assets/ind-construction.webp'
import indEnergy from '@/assets/ind-energy.webp'
import indEnterprise from '@/assets/ind-enterprise.webp'
import indLogistics from '@/assets/ind-logistics.webp'
import indManufacturing from '@/assets/ind-manufacturing.webp'
import indMining from '@/assets/ind-mining.webp'
import presensiGate from '@/assets/presensi-gate.webp'
import presensiSuite from '@/assets/presensi-suite.webp'
import safetySystem from '@/assets/safety-system.webp'
import sceneProblems from '@/assets/scene-problems.webp'
import sceneScale from '@/assets/scene-scale.webp'
import omaseLogo from '@/assets/omase-logo.webp'
import baentechLogo from '@/assets/baentech.webp'
import whyCustomComparison from '@/assets/why-custom-comparison.webp'

/**
 * Everything on this page that is NOT display text: assets, intrinsic
 * dimensions, links, ids, icon names, and numeric sample data.
 *
 * All copy lives in `src/i18n/locales/*` and is reached with `t()` or
 * `useSection()`. Keeping the two apart means a translation can never move a
 * layout or break an image, and adding a locale never touches this file.
 */

/** Intrinsic sizes of the source renders — used to reserve layout space. */
export const WIDE = { width: 1672, height: 941 }
export const SQUARE = { width: 1254, height: 1254 }

export const brand = {
  logo: omaseLogo,
  logoSize: 512,
  name: 'OMASE'
}

export const primaryNav = [
  { key: 'platform', href: '#platform' },
  { key: 'solutions', href: '#why' },
  { key: 'modules', href: '#ecosystem' },
  { key: 'industries', href: '#industries' },
  { key: 'technology', href: '#technology' },
  { key: 'whyCustom', href: '#why-custom' },
  { key: 'contact', href: '#contact' }
]

export const footerNav = [
  { key: 'platform', href: '#platform' },
  { key: 'solutions', href: '#why' },
  { key: 'industries', href: '#industries' },
  { key: 'technology', href: '#technology' },
  { key: 'whyCustom', href: '#why-custom' },
  { key: 'requestDemo', href: '#demo-form' },
  { key: 'contact', href: '#contact' }
]

export const media = {
  hero: { src: hseBoardroom, ...WIDE },
  proof: { src: announcement, width: 1537, height: 1023 },
  safetySystem: { src: safetySystem, ...SQUARE },
  hcSystem: { src: hcSystem, ...SQUARE },
  presensiGate: { src: presensiGate, ...WIDE },
  presensiSuite: { src: presensiSuite, ...WIDE },
  problems: { src: sceneProblems, width: 1920, height: 353 },
  closing: { src: sceneScale, width: 1920, height: 333 },
  comparison: { src: whyCustomComparison, width: 1536, height: 1024 },
  baentech: { src: baentechLogo, width: 1536, height: 1024 },
  /** Index-aligned with `sections.platform.highlights` in the locale files. */
  platformHighlights: [
    { src: safetySystem, ...SQUARE },
    { src: hcSystem, ...SQUARE }
  ],
  /** Index-aligned with `sections.platform.gallery.tabs`. */
  galleryTabs: [
    { hero: { src: hseDualScreen, ...WIDE }, shots: [{ src: hseControlRoom, ...WIDE }, { src: hseDesk, ...WIDE }] },
    { hero: { src: hcBoardroom, ...WIDE }, shots: [{ src: hcDesktop, ...WIDE }, { src: hcLaptop, ...WIDE }] }
  ],
  /** Index-aligned with `sections.industries.items`. */
  industries: [
    { src: indMining, ...WIDE },
    { src: indConstruction, ...WIDE },
    { src: indManufacturing, ...WIDE },
    { src: indLogistics, ...WIDE },
    { src: indEnergy, ...WIDE },
    { src: indEnterprise, ...WIDE }
  ]
}

/** Sample figures shown in the decorative console mock. */
export const platformData = {
  kpiValues: ['42', '1.8d', '0', '99.4%'],
  bars: [38, 52, 44, 61, 57, 72, 65, 80, 74, 88, 82, 96],
  approvalTones: ['brand', 'warn', 'info', 'brand'],
  galleryTabIds: ['HSE', 'HCGA']
}

/** Icon names for `sections.whyCustom.benefits`, in order. */
export const benefitIcons = ['identity', 'bolt', 'pulse', 'star', 'gear', 'value']

/** Contact channels. Not translatable — these are addresses, not prose. */
export const contact = {
  whatsapp: {
    number: '+62 812-9050-4997',
    href: 'https://wa.me/6281290504997'
  },
  email: {
    address: 'yupismanbaene@gmail.com',
    href: 'mailto:yupismanbaene@gmail.com'
  }
}

/**
 * Live demo environments. Credentials are reproduced exactly as supplied —
 * they are literal login strings, so no spelling is normalised.
 */
export const demoAccess = {
  options: [
    { id: 'admin', href: 'https://admin.baen.tech', icon: 'desktop' },
    { id: 'mobile', href: 'https://mobile.baen.tech', icon: 'mobile' }
  ],
  credentials: [
    { key: 'email', value: 'adminr@demo.com' },
    { key: 'password', value: 'administartor' }
  ]
}

export const builtBy = {
  name: 'Baentech Solution'
}
